module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chat-fullscreen",
    class: {
      active: _vm.showImg
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.hideFullscreenImg($event)
      }
    }
  }, [_c('div', {
    staticClass: "chat-mask"
  }), _vm._v(" "), _c('div', {
    ref: "chatImg",
    staticClass: "chat-image"
  })])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-b055a84a", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-b055a84a"}!./~/vux-loader/src/before-template-compiler-loader.js!./~/vux-loader/src/template-loader.js!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/components/FullscreenImg.vue
// module id = 384
// module chunks = 26